import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { __ } from 'react-i18n';
import { onlyPublic } from '../../utilities/only-public';
import { push } from 'react-router-redux';

import { FormInputComponent } from 'eshop-defaults';
import { ButtonPrimary } from 'eshop-defaults';
import { Title } from 'eshop-defaults';
import { ErrorAlert } from 'eshop-defaults';
import { Loader } from 'eshop-defaults';
import { SuccessAlert } from 'eshop-defaults';
import { Button } from 'eshop-defaults';
import { FlexColCenter } from 'eshop-defaults';

import { AuthContainer } from '../../components/Auth/AuthComponent';

interface State {
  password: string;
  passwordAgain: string;
  loading: boolean;
  err: string;
  changed: boolean;
}

interface Props {
  dispatch: any;
  params: {
    token: string;
  };
  API: any;
}

class NewPassword extends React.Component<Props, State> {
  state = {
    password: '',
    passwordAgain: '',
    loading: false,
    err: '',
    changed: false,
  };

  onPasswordChange = e => this.setState({ password: e.target.value });
  onPasswordAgainChange = e => this.setState({ passwordAgain: e.target.value });

  onClick = async e => {
    e.preventDefault();

    const { password, passwordAgain } = this.state;
    if (!password.trim()) {
      return;
    }

    if (password !== passwordAgain) {
      this.setState({ err: __('Heslá sa nezhodujú') });
      return;
    }

    try {
      this.setState({ loading: true });
      await this.props.API.newPassword(
        {
          xLostPasswordToken: this.props.params.token,
        },
        {
          new_password: password,
        },
      );

      this.setState({
        ...this.state,
        loading: false,
        changed: true,
      });
    } catch (e) {
      let err;
      if (e.message === 'Not Found') {
        err = __('Neznámy token');
      } else if (e.message === 'Forbidden') {
        err = __('Token vypršal');
      } else {
        err = __('Nepodarilo sa zmeniť heslo');
      }
      this.setState({ loading: false, err });
    }
  };

  render() {
    return (
      <AuthContainer>
        <ContentWrapper>
          <Title
            style={{ width: '100%', margin: '0 5%', marginBottom: '20px' }}
          >
            {__('Nastavenie nového hesla')}
          </Title>
          {this.state.changed === false ? (
            <NewPasswordForm>
              <FormInputComponent
                type="password"
                placeholder={__('Nové heslo')}
                value={this.state.password}
                onChange={this.onPasswordChange}
                disabled={this.state.loading}
              />
              <FormInputComponent
                type="password"
                placeholder={__('Heslo znova')}
                value={this.state.passwordAgain}
                onChange={this.onPasswordAgainChange}
                disabled={this.state.loading}
              />
              <ButtonLabel>
                <ButtonPrimary click={this.onClick}>
                  {this.state.loading ? (
                    <Loader
                      loading={true}
                      style={{ transform: 'scale(0.35)' }}
                      primaryColor="rgba(163, 239, 243, 1)"
                      secondaryColor="rgba(163, 239, 243, 0.4)"
                    />
                  ) : (
                    __('Zmeniť heslo')
                  )}
                </ButtonPrimary>
              </ButtonLabel>
            </NewPasswordForm>
          ) : (
            <React.Fragment>
              <SuccessAlert
                style={{ width: '100%' }}
                message={`${__('Heslo bolo úspešne zmenené')}`}
              />
              <Button
                style={{
                  marginTop: '20px',
                }}
                padding="14px 30px"
                height="auto"
                width="auto"
                fontSize="16px"
                radius="24px"
                color="#7ECED2"
                click={this.goToLogin}
              >
                Prejsť na prihlásenie
              </Button>
            </React.Fragment>
          )}

          {this.state.err && (
            <ErrorAlert
              closeAlert={this.closeAlert}
              style={{ width: '100%', marginTop: '40px' }}
              message={this.state.err}
            />
          )}
        </ContentWrapper>
      </AuthContainer>
    );
  }

  private goToLogin = () => {
    this.props.dispatch(push(__('routes:prihlasenie')));
  };

  private closeAlert = () => {
    this.setState({
      ...this.state,
      err: '',
    });
  };
}

const NewPasswordForm = styled.form`
  width: 600px;

  @media only screen and (max-width: 800px) {
    width: 90%;
  }
`;

const ButtonLabel = styled.div`
  margin-top: 25px;
`;

const ContentWrapper = styled(FlexColCenter)``;

export default onlyPublic(connect()(NewPassword));
